import React, { useEffect } from 'react';
import styled from 'styled-components';
export const Iframe = ({ src, originUrl = src, logger }) => {
    useEffect(() => {
        const handleIframePostMessage = (event) => {
            const iframe = document.querySelector('iframe[name=cta-iframe]');
            const iframeUrl = new URL(originUrl);
            if (event.origin === iframeUrl.origin) {
                try {
                    const messageDataJson = JSON.parse(event.data);
                    if (messageDataJson.height) {
                        iframe.height = `${messageDataJson.height}px`;
                    }
                }
                catch (_a) {
                    logger === null || logger === void 0 ? void 0 : logger.warn('No message data');
                }
            }
        };
        window.addEventListener('message', handleIframePostMessage);
        return () => {
            window.removeEventListener('message', handleIframePostMessage);
        };
    }, [originUrl, logger]);
    return React.createElement(StyledIframe, { name: "cta-iframe", src: src, width: "100%" });
};
const StyledIframe = styled.iframe `
  border: 0;
`;
